import { map } from "@/utils";
import { POINT_RADIUS } from "@/views/reports/widgets/InsightWidgets/ImpactScore/settings";

import { ImpactScoreData, Point } from "./types";

export const placePoints = (channels: ImpactScoreData[]): Point[] => {
  return channels.map((data) => ({
    ...data,
    left: map(data.sentiment_value, -1, 1, 0, 100),
    top: map(data.reach_value || 0, -1, 1, 100, 0),
    radius: POINT_RADIUS,
  }));
};
